module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-ons-page', [_c('div', {
    staticClass: "background"
  }), _vm._v(" "), _c('img', {
    staticClass: "home-menu_close",
    attrs: {
      "src": require("@/assets/images/close_button.svg")
    },
    on: {
      "click": _vm.hideMenu
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('nav', {
    staticClass: "home-menu"
  }, [_c('ul', [_c('li', {
    staticClass: "primary"
  }, [_c('a', {
    staticClass: "label",
    attrs: {
      "href": "./home.html"
    }
  }, [_vm._v("\n            ホーム\n          ")])])])])]), _vm._v(" "), _c('v-ons-row', {
    staticClass: "private-menu"
  }, [_c('v-ons-col', {
    staticClass: "private-menu_1",
    on: {
      "click": _vm.goToPrivateMenu
    }
  }), _vm._v(" "), _c('v-ons-col', {
    staticClass: "private-menu_2"
  }), _vm._v(" "), _c('v-ons-col', {
    staticClass: "private-menu_3"
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-429f73a5","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/menu.vue
// module id = 559
// module chunks = 0